import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                closePopin: 'closePopin'
            }
        }
    }

    init() {
        this.popinsWrap = this.el;
        this.currentPopin = null;
        this.currentMediaId = null;

        document.querySelectorAll('[data-popin-id]').forEach((elt) => {
            elt.addEventListener('click', (e) => {
                e.preventDefault();
                this.openPopin(elt.getAttribute('data-popin-id'))
            });
        });
    }

    getPopin(id) {
        let elt = this.el.querySelector('.o-popin[data-popin-id="' + id + '"]');
        return elt ? elt : null;
    }
    
    openPopin(id) {
        if (!id) return;
        
        this.call('stop', 'Scroll');

        let popin = this.getPopin(id);
        if (!popin) return;

        this.currentPopin = popin;
        this.currentMediaId = this.currentPopin.getAttribute('data-module-player');

        this.popinsWrap.classList.add('-visible');
        this.currentPopin.classList.add('-visible');

        this.playMedia();
    }

    closePopin() {
        this.call('start', 'Scroll');

        this.popinsWrap.classList.remove('-visible');
        this.currentPopin.classList.remove('-visible');
        
        this.pauseMedia();
    }

    playMedia() {
        if (this.currentMediaId) {
            this.call('play', false, 'Player', this.currentMediaId);
        }
    }

    pauseMedia() {
        if (this.currentMediaId) {
            this.call('pause', false, 'Player', this.currentMediaId);
        }
    }
}
